import Svg, { Path, Rect } from 'react-native-svg'
const Report = ({ color = '#000' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none">
    <Rect width={40} height={40} fill={color} fillOpacity={0.06} rx={20} />
    <Path
      stroke={color}
      strokeWidth={2}
      d="M14 12a1 1 0 0 1 1-1h8.936a1 1 0 0 1 .72.306l.71-.684-.71.684 1.017 1.055 1.047 1.085.72-.694-.72.694a1 1 0 0 1 .28.694V28a1 1 0 0 1-1 1H15a1 1 0 0 1-1-1V12Z"
    />
    <Path stroke={color} strokeLinecap="round" strokeWidth={2} d="M18.286 19.667h2.143M18.286 23h4.285" />
    <Path stroke={color} strokeWidth={2} d="M22.643 10v3.556a2 2 0 0 0 2 2h2.285" />
  </Svg>
)
export default Report
